import { IPayOutResponse } from "../../utils/types";
import { apiManager } from "../api-manager";

export const payout = async (body: IPayOutResponse) => {
  const res = await apiManager.post("/stripe/transfers", body);
  return res;
};
